/**
 * Marketplace API client — centralizes all marketplace HTTP calls.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const auth = (t) => (t ? { Authorization: `Bearer ${t}` } : {});

export const marketApi = {
  categories:      () => axios.get(`${API}/marketplace/categories`).then(r => r.data),

  list: (params = {}) => {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== "" && v !== null && v !== undefined) usp.set(k, v);
    });
    return axios.get(`${API}/marketplace/listings?${usp}`).then(r => r.data);
  },

  detail: (lid) => axios.get(`${API}/marketplace/listings/${lid}`).then(r => r.data),

  create: (token, body) =>
    axios.post(`${API}/marketplace/listings`, body, { headers: auth(token) }).then(r => r.data),

  update: (token, lid, patch) =>
    axios.patch(`${API}/marketplace/listings/${lid}`, patch, { headers: auth(token) }).then(r => r.data),

  remove: (token, lid) =>
    axios.delete(`${API}/marketplace/listings/${lid}`, { headers: auth(token) }).then(r => r.data),

  toggleFavorite: (token, lid) =>
    axios.post(`${API}/marketplace/listings/${lid}/favorite`, {}, { headers: auth(token) }).then(r => r.data),

  favoriteStatus: (token, lid) =>
    axios.get(`${API}/marketplace/listings/${lid}/favorite-status`, { headers: auth(token) }).then(r => r.data),

  myListings: (token) =>
    axios.get(`${API}/marketplace/me/listings`, { headers: auth(token) }).then(r => r.data),

  myFavorites: (token) =>
    axios.get(`${API}/marketplace/me/favorites`, { headers: auth(token) }).then(r => r.data),

  contactSeller: (token, lid, message) =>
    axios.post(`${API}/marketplace/listings/${lid}/contact`,
      { listing_id: lid, initial_message: message },
      { headers: auth(token) }).then(r => r.data),

  threads: (token) =>
    axios.get(`${API}/marketplace/threads`, { headers: auth(token) }).then(r => r.data),

  messages: (token, tid, since) => {
    const q = since ? `?since=${encodeURIComponent(since)}` : "";
    return axios.get(`${API}/marketplace/threads/${tid}/messages${q}`, { headers: auth(token) }).then(r => r.data);
  },

  sendMessage: (token, tid, body) =>
    axios.post(`${API}/marketplace/threads/${tid}/messages`, { body }, { headers: auth(token) }).then(r => r.data),
};

export const CONDITIONS = [
  { id: "new", label: "Nuevo" },
  { id: "like_new", label: "Como nuevo" },
  { id: "used", label: "Usado" },
  { id: "refurbished", label: "Reacondicionado" },
  { id: "n_a", label: "N/A (servicio)" },
];

export const SORT_OPTIONS = [
  { id: "recent", label: "Más recientes" },
  { id: "price_asc", label: "Precio: menor a mayor" },
  { id: "price_desc", label: "Precio: mayor a menor" },
  { id: "popular", label: "Más populares" },
];
